import React, { ReactNode, useMemo, useState } from "react";
import { Item } from "@charty/legend/item/model";
import { useTheme } from "@glossy/theme";
import { AbstractDate, Range } from "@linkfluence/models/date";
import { Locale } from "@linkfluence/models/locale";
import Chart from "./chart";
import { getLegendSeries, useColors } from "./data";
import Legend from "./legend";

export type Serie = {
  [key: string]: number;
};

interface IProps {
  series: Serie[];
  keys: string[];
  onClickStream?: (
    uid: string | number,
    range: { from: AbstractDate; to: AbstractDate }
  ) => void;
  onClickLegend?: (s: string) => void;
  className?: string;
  offsetType?: "none" | "silhouette";
  curve?: "basis" | "linear";
  locale?: Locale;
  tooltip?: (serie: Item, total: number) => ReactNode;
  colors?: string[];
  range?: Range;
  total?: number;
  disableAnimation?: boolean;
  displayVolumes?: boolean;
}

const StreamChart = ({
  series,
  keys,
  offsetType = "silhouette",
  curve = "basis",
  locale = Locale.English,
  colors,
  onClickStream,
  className,
  tooltip,
  range,
  total,
  onClickLegend,
  disableAnimation = false,
  displayVolumes,
}: IProps) => {
  const [hovered, setHovered] = useState(null);
  const theme = useTheme();
  const _colors = useColors(hovered, colors, keys, theme);
  const legendSeries = useMemo(
    () => getLegendSeries(series, colors),
    [colors, series]
  );
  return (
    <div style={{ height: "100%" }} className={className}>
      <Legend
        total={total}
        setHovered={setHovered}
        locale={locale}
        onClickLegend={onClickLegend}
        tooltip={tooltip}
        range={range}
        series={legendSeries}
        disableAnimation={disableAnimation}
        displayVolumes={displayVolumes}
      />
      <Chart
        series={series}
        keys={keys}
        theme={theme}
        colors={_colors}
        offsetType={offsetType}
        curve={curve}
        onClickStream={onClickStream}
        legendSeries={legendSeries}
      />
    </div>
  );
};

export default StreamChart;
